export default "__VITE_PUBLIC_ASSET__5957b7f5__"